import api from "../api";
import { useEffect, useRef, useState } from "react";

const useFetchPlans = () => {
  const [paymentPlans, setPaymentPlans] = useState([]);

  const fetchPaymentPlans = async () => {
    const { data } = await api.get("/api/billing/payment_plans");
    setPaymentPlans(data);
  };

  const fetchCalledRef = useRef(false);

  useEffect(() => {
    if (!fetchCalledRef.current) {
      fetchCalledRef.current = true;
      fetchPaymentPlans();
    }
  }, []);

  return { paymentPlans };
};

export default useFetchPlans;
